import Phaser from 'phaser';
import { appConfig } from '@config/app.config';
import { animationEase } from '@config/animation.config';
import { getBootstrap } from '@core/bootstrap/GameBootstrap';
import { ServiceTokens } from '@core/bootstrap/ServiceRegistry';
import type { LocalizationService } from '@localization/LocalizationService';
import { TextButton } from '@ui/components/TextButton';
import { sceneKeys } from '@utils/constants';

interface GameOverData {
  score: number;
}

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super(sceneKeys.gameOver);
  }

  create(data: GameOverData): void {
    const { registry } = getBootstrap();
    const localization = registry.get<LocalizationService>(ServiceTokens.localization);
    const score = data?.score ?? 0;

    this.cameras.main.setBackgroundColor('#0f1115');
    this.cameras.main.fadeIn(300, 0, 0, 0);

    const title = this.add
      .text(appConfig.gameWidth / 2, 420, localization.t('gameover.title'), {
        fontFamily: 'Arial, sans-serif',
        fontSize: '56px',
        color: '#ffffff',
        fontStyle: 'bold',
      })
      .setOrigin(0.5)
      .setAlpha(0)
      .setScale(0.92);

    const scoreText = this.add
      .text(appConfig.gameWidth / 2, 540, localization.t('gameover.score', { score }), {
        fontFamily: 'Arial, sans-serif',
        fontSize: '40px',
        color: '#a8b0c0',
      })
      .setOrigin(0.5)
      .setAlpha(0);

    const retryButton = TextButton.create(
      this,
      appConfig.gameWidth / 2,
      appConfig.gameHeight / 2 + 120,
      localization.t('gameover.retry'),
      () => {
        this.cameras.main.fadeOut(200, 0, 0, 0);
        this.time.delayedCall(200, () => {
          this.scene.start(sceneKeys.gameplay);
        });
      },
    );

    retryButton.setAlpha(0);

    this.tweens.add({
      targets: title,
      alpha: 1,
      scale: 1,
      duration: 380,
      ease: animationEase.outBack,
    });

    this.tweens.add({
      targets: scoreText,
      alpha: 1,
      duration: 320,
      delay: 140,
      ease: animationEase.outCubic,
    });

    this.tweens.add({
      targets: retryButton,
      alpha: 1,
      duration: 320,
      delay: 260,
      ease: animationEase.outCubic,
    });
  }
}
